import styled from 'styled-components';
import { media } from 'helpers/MediaHelper';
import { colors } from 'helpers/ColorHelper';
import Divider from 'components/ui/Divider';

export const CardBase = styled.div`
  color: ${colors.DARKEST_GRAY};
  border-radius: 20px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.125);
  text-align: left;
  padding: 24px 24px 16px 24px;
  background: ${colors.WHITE};

  ${media.mobile`
    padding: 16px;
  `};
`;

export const Card = styled(CardBase)`
  margin-top: 32px;
  display: block;
  cursor: ${props => props.cursor || 'default'};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  ${media.mobile`
    justify-content: space-between;
  `};
`;

export const Body = styled.div`
  display: flex;
  justify-content: space-between;
  margin: ${props => props.margin || '0px'};
`;

export const Col = styled.div`
  width: 25%;
`;

export const BoldTitle = styled.p`
  font-weight: 500;
  font-size: 24px;
  margin: 0;
  color: ${colors.BLACK_RUSSIAN};
`;

export const GreyText = styled.p`
  margin: 0;
  font-size: 16px;
  color: ${colors.CHAR_COUNT};
`;

export const BoldText = styled.p`
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: ${colors.SPACE_GRAY};
`;

export const HorizontalDivider = styled(Divider)`
  margin-top: 8px;
  margin-bottom: 16px;
  height: 2px;
  background-color: ${colors.PALE_GREY};
`;

export const VerticalDivider = styled.div`
  width: 2px;
  background-color: ${colors.PALE_GREY};
`;

export const MobileItem = styled.div`
  width: ${props => props.width || '50%'};
  text-align: ${props => props.textAlign || 'left'};
  border-right: ${props => (props.borderRight ? `2px solid ${colors.PALE_GREY}` : 'none')};
`;

export const StyledArrowButton = styled.button`
  color: ${colors.ULTRAMARINE_BLUE};
  cursor: pointer;
  background: none;
  border: none;
  display: flex;
  align-items: center;
`;
